/* eslint-disable no-constant-condition */
import React from "react"
import intl from "react-intl-universal"
import { ChartLereyJennings } from "../../../Releases/components/ChartLereyJennings"
import { TableAnalysis } from "../../../Releases/components/TableAnalysis"
import styles from "./index.module.scss"

const DataLaunchs = (props) => {
  const { oAnalyte, runs } = props

  if (!oAnalyte) return null

  const bIsQuantitativeAnalaite = oAnalyte?.anlt_type === "Quantitativo"
  const cRunsDataHeaderText = bIsQuantitativeAnalaite ? intl.get("ciq.release_details.data_launch.title.chart") : intl.get("ciq.release_details.data_launch.title.table")

  const aSortedRuns = [...runs]?.sort((a, b) => a?.eqpanltrun_number - b?.eqpanltrun_number)

  return (
    <div className={styles.runsDataContainer}>
    <div className={styles.headerData}>
      <p>{cRunsDataHeaderText}</p>
    </div>
    {bIsQuantitativeAnalaite ? (
      <div className={styles.chartContainer}>
        <ChartLereyJennings runs={aSortedRuns} pagination={false} />
      </div>
    ) : (
      <TableAnalysis runs={aSortedRuns} className={styles.tableAnalysis} pagination={false}/>
    )}
  </div>
  )
}

export default DataLaunchs
